import {
  createFileRoute,
  notFound,
  stripSearchParams,
} from '@tanstack/react-router';
import { z } from 'zod';
import { ReportViewerLayout } from '../../../../../../../pages/interpretiveReports/ReportViewer';
import { RouterContext } from '../../../../../../../router';
import { interpretiveReportQueryOptions } from '../../../../../../../services/queries';
import {
  READ_ORGANIZATION_INTERPRETIVE_REPORTS,
  READ_PLATFORM_INTERPRETIVE_REPORTS,
  READ_USER_INTERPRETIVE_REPORTS,
} from '../../../../../../../utils/permissions';

// Whether the chat and comments panels show. The defaults are stripped from
// the URL, so plain links land with the chat showing.
const searchDefaults = { chat: 'open' as const, comments: 'closed' as const };
const searchSchema = z.object({
  chat: z.enum(['open', 'closed']).default(searchDefaults.chat),
  comments: z.enum(['open', 'closed']).default(searchDefaults.comments),
});

function interpretationBeforeLoad({ context }: { context: RouterContext }) {
  const canReadReports =
    context.auth.hasPermission(READ_USER_INTERPRETIVE_REPORTS) ||
    context.auth.hasPermission(READ_ORGANIZATION_INTERPRETIVE_REPORTS) ||
    context.auth.hasPermission(READ_PLATFORM_INTERPRETIVE_REPORTS);
  if (!canReadReports) {
    throw notFound();
  }
}

async function interpretationLoader({
  context,
  params,
}: {
  context: RouterContext;
  params: { sampleSetId: string; interpretationId: string };
}) {
  try {
    await context.queryClient.ensureQueryData(
      interpretiveReportQueryOptions(
        params.interpretationId,
        context.auth.hasPermission
      )
    );
    return { interpretationId: params.interpretationId };
  } catch {
    throw notFound();
  }
}

export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/interpretations/$interpretationId'
)({
  staticData: { ddViewName: 'experiments-report-viewer' },
  validateSearch: searchSchema,
  search: {
    middlewares: [stripSearchParams(searchDefaults)],
  },
  beforeLoad: interpretationBeforeLoad,
  loader: interpretationLoader,
  component: ReportViewerLayout,
});
